module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TJBjBb/tc-custom/9781439675212.jpg?1702530413054",
      "alt": "This image is the cover for the book History Lover's Guide to North Carolina, A, History Lovers Guide"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("History Lover's Guide to North Carolina, A, History Lovers Guide\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Tour the Old North State's famous--and not-so-famous--historic sites.")])]), _c('p', [_vm._v("\"First in Freedom,\" \"First in Flight,\" and \"First, Farthest and Last\" are all honorifics that have been used to describe North Carolina's well-known history. Learn the truth behind each of these epithets and other tales from the sands of the Outer Banks to the bustling cities of the Piedmont and the western mountains. Tour the state's famous historic homes, gardens and cemeteries. Dive deep into its military conflicts, from the golden age of piracy to the Second World War. ")]), _c('p', [_vm._v("\"Join North Carolina's veteran historian, Michael C. Hardy, for an exploration of the many sites, monuments, museums, and public spaces that tell story of North Carolina's history.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael C. Hardy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael C. Hardy is a widely published author of North Carolina history. Named the 2010 North Carolina Historian of the Year by the North Carolina Society of Historians, Hardy has also been awarded the 2018 James I. Robertson Literary Prize; 2015 Volunteer of the Year for the Pisgah District, Blue Ridge Parkway; and the Alice Parker Award for Outstanding Work in Literature and Arts from his alma mater, the University of Alabama. When not researching, writing and traveling, he shares his love of history by volunteering at historic sites.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0